import { Button, message, Modal } from 'antd'
import useModalShow from '../../../elements/Hooks/useModalShow'
import Auth from '../../../modules/Authentication'
import React, { useState } from 'react'

const auth = new Auth()
function AwbPull({ carrier, track }) {
  // const url = `/foxxapi/tracking/shipping/${carrier}/${track}/`
  const url = `https://tracking.mondiale.com/shipping/track?carrier=dhl&track=8158750994`

  const { visible, onShow, onCancel } = useModalShow()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})

  async function onPull() {
    setLoading(true)
    try {
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        // authorization: `Bearer ${auth.getAccessToken()}`,
      }
      const response = await fetch(url, { headers })
      const json = await response.json()
      console.log(json)
      setData(json)
      onShow()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || 'Not Found')
    }
    setLoading(false)
  }

  return (
    <div>
      <Button type="primary" loading={loading} onClick={onPull}>
        Pull
      </Button>
      <Modal title={'title'} visible={visible} onOk={onCancel} onCancel={onCancel}>
        {JSON.stringify(data)}
      </Modal>
    </div>
  )
}

export default AwbPull
